import { useCallback, useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import {
  Body,
  DialogContentStyled,
} from "../../../../patterns/modals/modallog/styles/styles";
import Btn from "../../../../components/buttons/Btn";
import CircularLoader from "../../../../components/loading/circularLoader";
import { formatDateGetTime } from "../../../../utils/formatDate";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import { GridTitleSeparator } from "../styles/style";
import { getOpenFinanceLog } from "../../../../repositories/qerpapi/v3/bankReconcilliation/BankReconcilliationRepository";
import { notify } from "../../../../utils/notify";

const ModalOpenFinanceLogs = ({
  open = false,
  handleClose = () => {},
  row = null,
}) => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const handleGetOpenFinanceLog = useCallback(async ({ agencyId }) => {
    try {
      setIsloading(true);
      const callback = await getOpenFinanceLog({ agencyId });

      if (!callback.success)
        return notify(callback.message || "Erro ao buscar logs.");

      setLogs(callback.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setIsloading(false);
    }
  }, []);

  useEffect(() => {
    if (!row) return;

    handleGetOpenFinanceLog({ agencyId: row.id });
  }, [row, handleGetOpenFinanceLog]);

  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle
        id="customized-dialog-title"
        children={<div>{`Logs: ${row.nickname || ""}`}</div>}
      />
      <DialogContentStyled>
        {isLoading ? (
          <Grid container justifyContent="center">
            <CircularLoader color="primary" />
          </Grid>
        ) : logs.length ? (
          <Body>
            <Grid container>
              <Grid item container xs>
                <Timeline align="alternate">
                  {logs.map((value, index) => (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent>
                        <Typography color="textSecondary">
                          {formatDateGetTime({
                            date: value.created_at || "",
                            separator: "/",
                            format: "dd/mm/yyyy/hh:mm:ss",
                          })}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot color="primary" />
                        {logs.length !== index + 1 && <TimelineConnector />}
                      </TimelineSeparator>
                      <TimelineContent>
                        <Typography>{`${value.description || "-"} ${
                          (value.user?.nome &&
                            `Por ${value.user?.nome || ""}.`) ||
                          ""
                        }`}</Typography>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
                </Timeline>
              </Grid>
            </Grid>
          </Body>
        ) : (
          <GridTitleSeparator container justifyContent="space-between">
            <Grid item md={12} xs={12}>
              <span>SEM REGISTRO NO SISTEMA.</span>
            </Grid>
          </GridTitleSeparator>
        )}
      </DialogContentStyled>
      <DialogActions>
        <Btn
          onClick={handleClose}
          bgcolor="tertiary"
          label="Fechar"
          disabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalOpenFinanceLogs;
